import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "options", "searchable", "selectedOption", "helperText"];
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useFormContext, Controller } from "react-hook-form";
import SelectTwo from "@componentsShared/SelectTwo/SelectTwo";
import stl from "./RHFSelectTwo.module.css";
import { useTranslation } from "@i18n";
export function RHFSelectTwo(_ref) {
  var name = _ref.name,
    options = _ref.options,
    searchable = _ref.searchable,
    selectedOption = _ref.selectedOption,
    helperText = _ref.helperText,
    other = _objectWithoutProperties(_ref, _excluded);
  var _useFormContext = useFormContext(),
    control = _useFormContext.control,
    setValue = _useFormContext.setValue,
    setError = _useFormContext.setError;
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Controller, {
    name: name,
    control: control,
    render: function render(_ref2) {
      var field = _ref2.field,
        error = _ref2.fieldState.error;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(stl.selectWrapper, " ").concat(isFocused ? stl.focused : "", " ").concat(error ? stl.hasError : "")
      }, /*#__PURE__*/React.createElement(SelectTwo, _extends({}, field, {
        className: stl.inputFieldSearch,
        options: options,
        searchable: searchable,
        selectedOption: options.find(function (option) {
          return option.id === field.value;
        }) || null,
        onChange: function onChange(option) {
          setIsFocused(false);
          if (option && option.id) {
            field.onChange(option.id);
            setValue(name, option.id);
          } else {
            field.onChange("");
            setValue(name, "");
          }
        },
        value: field.value
      }, other)), helperText && /*#__PURE__*/React.createElement("span", {
        className: stl.helperText
      }, helperText), error && /*#__PURE__*/React.createElement("span", {
        className: "errorText"
      }, tShort(error.message, {
        ns: "validations"
      })));
    }
  });
}